<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import indowProHeaderBackground from './images/indowpro-header-background.svg';
	import indowProInstallers from './images/indowpro-installers.png';
	import indowProLogo from './images/indowpro-logo.svg';

	import Button from '$lib/Components/Layout/Button/Button.svelte';
	import BuildingTypes from '$lib/PageSections/BuildingTypes/BuildingTypes.svelte';
</script>

<Section
	backgroundColor="blue"
	class="
   block bg-cover bg-no-repeat pt-12 bg-blend-exclusion
   md:pb-24
 "
	style={`background-image:url('${indowProHeaderBackground}'); background-position-y: 4rem; background-position-x: right;`}
>
	<div>
		<Image src={indowProLogo} class="mb-8" />
		<h1>Unlock a New Market with IndowPRO™</h1>
	</div>
</Section>

<Section backgroundColor="white">
	<h2>How Many Jobs Do You Almost Win?</h2>
	<p class="mb-12">
		Ever bid on a commercial window replacement job—only to hear: "Too expensive
		& disruptive." Or "We'll just live with it." Now imagine calling that
		building manager back and saying: "We've got a smarter solution."
	</p>

	<h3 class="mb-8">
		<span class="text-indow-grey-dark">Meet IndowPRO™</span>
		<br />
		The Smart, Profitable Retrofit Window System Designed for Glazing Contractors
	</h3>
	<p>
		IndowPRO is a high-performance secondary glazing system designed for glazing
		contractors. It installs inside the existing window, delivering major energy
		savings, noise reduction, and tenant comfort improvements, all without the
		need for a full tear-out or demolition.
	</p>

	<div
		class="
    grid w-full grid-cols-1 gap-12
    md:grid-cols-2
  "
	>
		<div>
			<ul class="mx-auto mb-8 flex w-full max-w-2xl flex-col gap-3">
				<li>
					<p class="text-left">Installs in 15-20 minutes per opening</p>
				</li>
				<li>
					<p class="text-left">Ships disassembled for easier logistics</p>
				</li>
				<li>
					<p class="text-left">
						Frames snap together and mount with screws or VHB tape
					</p>
				</li>
				<li>
					<p class="text-left">
						Works with multiple glazing types including Acoustic Lami, VIG,
						Low-E, or lightweight acrylic
					</p>
				</li>
				<li>
					<p class="text-left">
						Reliably delivers an airtight seal—even in out-of-square openings
					</p>
				</li>
			</ul>
			<Button href="#join">Join Now</Button>
		</div>
		<Image class="rounded-lg shadow-md" src={indowProInstallers} />
	</div>
</Section>

<Section>
	<h2 class="text-left">Proven in the Field, Trusted Nationwide</h2>
	<p class="text-left">
		Indow systems have been installed in thousands of commercial and
		institutional buildings across North America: from hotels and schools to
		city halls and office towers.
	</p>

	<BuildingTypes />
</Section>

<Section backgroundColor="white">
	<h2 class="mb-8">Why Glazing Contractors Choose IndowPRO</h2>

	<ul class="mx-auto flex w-full max-w-2xl flex-col gap-3">
		<li>
			<h3 class="mb-1 text-left text-indow-grey-dark normal-case">
				New Business
			</h3>
			<p class="text-left">
				40% of commercial windows are still single-pane, and only 0.3% get
				replaced each year. IndowPRO opens a new market
			</p>
		</li>
		<li>
			<h3 class="mb-1 text-left text-indow-grey-dark normal-case">
				Fast Training
			</h3>
			<p class="text-left">
				Live video installation and measurement training is free
			</p>
		</li>
		<li>
			<h3 class="mb-1 text-left text-indow-grey-dark normal-case">
				Ongoing Support
			</h3>
			<p class="text-left">Technical + sales support throughout the process</p>
		</li>
		<li>
			<h3 class="mb-1 text-left text-indow-grey-dark normal-case">
				Maximize Revenue Streams
			</h3>
			<p class="text-left">
				Service and product revenue from measure & installation, framing, and
				glazing
			</p>
		</li>
	</ul>
</Section>
<Section backgroundColor="white" id="join">
	<h2>Join the IndowPRO Dealer Network</h2>
	<p>
		If you are a glazing, curtain wall, or building envelope contractor who
		wants to grow a retrofit business for commercial properties - you may be a
		great fit for IndowPRO's dealer program.
	</p>
	<p>
		We're currently accepting a limited number of applications. Review our <a
			target="_blank"
			href="/static/pdfs/Indow_Insurance_Certificate_Sample_IndowPRO.pdf"
			>insurance requirements</a
		>, fill out the form below and we'll be in touch with more information. If
		approved, we'll partner with you to bring premium window performance to your
		commercial clients.
	</p>

	<iframe
		title="google_sign"
		src="https://docs.google.com/forms/d/e/1FAIpQLSd1H8UCWpQHOPnahGJ2q6iCYGiVfadpHJSVpxZ2n24hdc9k_Q/viewform?embedded=true"
		seamless
		scrolling="yes"
		class="
    mb-6 h-[53em] w-full
    md:h-[48em]
  "
	></iframe>
</Section>
